import { ajax } from './ajax';
import { env } from './env';

// 首页展示 - 会员接口
export function homePage(data: HomePageParamsType): Promise<HomePageType> {
  return ajax('/mtScorepay/payDefer/inPay/homePage', {
    data,
    method: 'post',
    params: {
      member_id: env.memberId,
    },
  });
}

// 签约引导 - 会员接口
export function guideSign(data: GuideSignParamsType): Promise<GuideSignResponseType> {
  return ajax('/mtScorepay/guideSign', {
    data,
    method: 'post',
    shark: true,
    params: {
      member_id: env.memberId,
    },
  });
}

// 签约+支付 - 聚合接口
export function signPay(data: SignPayParamsType): Promise<SignPayResponstType> {
  return ajax('/payDefer/signPay', {
    data,
    method: 'post',
  });
}

// 签约引导 - 会员接口
export function postUniteSign(data: UniteSignParamsType & GuideSignParamsType): Promise<UniteSignResponseType> {
  return ajax('/mtScorepay/uniteSign', {
    data,
    method: 'post',
    shark: true,
    params: {
      member_id: env.memberId,
    },
  });
}

// 签约状态查询
export function getSignStatus(data: SignStatusExtraParamsType): Promise<WXSignResult> {
  return ajax('/mtScorepay/getSignStatus', {
    data,
    method: 'post',
    shark: true,
    params: {
      member_id: env.memberId,
    },
  });
}

// 查询订单状态 - 聚合接口
export function queryOrder(data: QueryOrderParamsType): Promise<QueryOrderResponseType> {
  return ajax('/cashier/queryorder', {
    data,
    method: 'post',
    shark: true,
  });
}

/**
 * 独立签约结果页面 - 聚合接口
 * @param data
 * @returns
 */
export function signResultPage(data: ResultPageParamsType): Promise<ResultPageResponseType> {
  return ajax('/growth/signresultpage', {
    data,
    method: 'post',
  });
}

export function getSummaryList(data: UnpaidParamsType): Promise<SummaryListResponseType> {
  return ajax('/paydefer/unpaid/summarylist', {
    data,
    method: 'post',
  });
}

export function getServiceRecord(data: UnpaidParamsType): Promise<ServiceRecordResponseType> {
  return ajax('/bnpl/repayment/serviceRecord', {
    data,
    method: 'post',
  });
}

export function postRepayConfirm(data: UnpaidParamsType): Promise<RepayConfirmResponseType> {
  return ajax('/bnpl/repayment/repayConfirm', {
    data,
    method: 'post',
  });
}

// 先用后付介绍页
export function introductionPage(data: IntroductionParamsType): Promise<IntroductionPageType> {
  return ajax('/mtScorepay/payDefer/inPay/paySuccessResultPage', {
    data,
    method: 'post',
  });
}

// 以下接口为支付中签约新流程履约后端提供新接口
// 首页展示
export function payDeferHomePage(data: PaydeferHomePageParamsType): Promise<HomePageType> {
  return ajax('/paydefer/homepage', {
    data,
    method: 'post',
    shark: true,
  });
}

// 流程控制器 /paydefer/qualifydispatcher
export function qualifyDispatcher(data: QualifyDispatcherParamsType): Promise<QualifyDispatcherType> {
  return ajax('/paydefer/qualifydispatcher', {
    data,
    method: 'post',
    shark: true,
  });
}

// 验证密码 /paydefer/check_paytoken
export function checkPayToken(data: CheckPayTokenParamsType): Promise<CheckPayTokenType> {
  return ajax('/paydefer/checkpaytoken', {
    data,
    method: 'post',
    shark: true,
  });
}

// paydelay 支付决策接口 /cashier/displayconsult
export function paydelayDisplayConsult(data: paydelayDisplayConsultType): Promise<DisplayConsultDataType> {
  return ajax('/cashier/displayconsult', {
    data,
    method: 'post',
    shark: true,
  });
}
// paydelay 页面展示 /paylater/showOpenPage
export function paydelayShowOpenPage(data: PaydelayShowOpenPageParamsType): Promise<PaydelayShowOpenPageType> {
  return ajax('/paylater/showOpenPage', {
    data,
    method: 'post',
    shark: true,
  });
}
//  先用后付（原安心付）签约结果页
export function showOpenStatusPage(data: BaseDataParamsType): Promise<ShowOpenStatusPageType> {
  return ajax('/paylater/showOpenStatusPage', {
    data,
    method: 'post',
    shark: true,
  });
}
// 用户第三方支付（支付宝、微信）
export function directpay(data: DirectpayParamsType): Promise<DirectpayDataType> {
  return ajax('/cashier/directpay', {
    data,
    method: 'post',
    shark: true,
  });
}
// 查询开户状态
export function checkUserStatus(): Promise<CheckUserStatusDataType> {
  return ajax(
    '/bnpl/user/status',
    {
      data: {
        ...env.coreBusinessParams,
        openProducts: env.creditType,
      },
      method: 'post',
    },
    true
  );
}
